'use strict';

// https://igorescobar.github.io/jQuery-Mask-Plugin/docs.html
module.exports = {
    validatePostalcode: function () {
        $('#zipCode').mask('0000');
    },
    validatePhone: function () {
        $('.input-phone').mask('00000000000000000000', {
            translation: {
                0: { pattern: /[0-9.-/+]/ }
            }
        });
    },
    validateName: function () {
        $('.input-text-only').mask('Z', {
            translation: {
                Z: { pattern: /[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.´`^¨'-]/, recursive: true }
            }
        });
    },
    validateDate: function () {
        $('.input-date').mask('00/00/0000',
            { placeholder: '__/__/____' }
        );
    },
    validateAddress2: function () {
        // by default the plugin will check for letters and numbers.
        // space added to be included.
        $('.input-address2').mask('AAAAAAAAAAAAAA', {
            translation: {
                A: { pattern: /^[A-Za-z0-9\s]*$/ },
                reverse: true
            }
        });
    },
    validatePostBox: function () {
        // only spaces, forward slash, letters and numbers are allowed.
        $('.input-postBox').mask('AAAAAAAA', {
            translation: {
                // eslint-disable-next-line no-useless-escape
                A: { pattern: /^[A-Za-z0-9\s\/]*$/, reverse: true }
            }
        });
    }
};
